/**
 * Extend the Window interface to include the `aap` property.
 * @typedef {typeof globalThis & { gtag?: (...args: any[]) => void }} CustomWindow
 */

const win = /** @type {CustomWindow} */ (window)

const GTM_CONTAINER_ID = 'GTM-KZ525569'

/**
 * @param {string} url The URL to track.
 * @returns {void}
 */
export const pageview = (url) => {
  if (typeof window !== 'undefined' && typeof win.gtag === 'function') {
    win.gtag('config', 'GT-PZQ399ZQ', {
      page_path: url,
    })
  }
}

/**
 * @param {{ action: string, params: object }} args The action to track.
 * @returns {void}
 */
export const event = ({ action, params }) => {
  if (typeof window !== 'undefined' && typeof win.gtag === 'function') {
    win.gtag('event', action, params)
  }
}

/**
 * @param {{ action: string, params: object, TRID: string }} args The action to track.
 * @returns {void}
 */
export const GTMEvent = ({ action, params, TRID }) => {
  if (typeof window !== 'undefined' && typeof win.gtag === 'function') {
    win.gtag('config', GTM_CONTAINER_ID, {
      event: action,
      ...params,
      TRID,
    })
  }
}
